// extracted by mini-css-extract-plugin
export default {"division1":"SelContent2_division1__Edn7I","division1Text":"SelContent2_division1Text__hPn17","division1Title":"SelContent2_division1Title__1i9N6"};